import { Box, Stack, Typography } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';
import { COLORS } from '@/styles/tokens/colors';

import {
  EducationalSlideH4,
  VERTICAL_SPACING,
} from '../../components/EducationalSlide.components';
import { SVGVariableContainer } from '../../components/SVGVariableContainer';
import WhyEstatePlanningGraph from './WhyEstatePlanningGraph.svg?react';
import WhyEstatePlanningLegend from './WhyEstatePlanningLegend.svg?react';

export function WhyEstatePlanningMatters({
  hideWealthDistributionGraph: hideGraph = false,
}: {
  hideWealthDistributionGraph?: boolean;
}) {
  return (
    <Stack spacing={VERTICAL_SPACING}>
      <Card variant="filled" sx={{ p: 2 }}>
        <EditableRegion regionId="description" />
      </Card>
      <Stack direction="row" spacing={2}>
        <Stack spacing={2} sx={{ width: hideGraph ? '100%' : '65%' }}>
          <EditableRegion regionId="list-section" />
        </Stack>

        {!hideGraph && <Box />}

        {!hideGraph && (
          <Stack spacing={2} sx={{ width: '35%' }}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Stack spacing={4} textAlign="center">
                <EducationalSlideH4>
                  30 year potential wealth distribution outcome
                </EducationalSlideH4>
                <SVGVariableContainer>
                  <WhyEstatePlanningGraph />
                  <WhyEstatePlanningLegend />
                </SVGVariableContainer>
                <Typography variant="body-xs" color={COLORS.NEUTRAL_GRAY[500]}>
                  Hypothetical estate distribution in 2055 on a current $10M
                  portfolio. Assumes $5M gift in 2025 and 5% annual after-tax
                  growth.
                </Typography>
              </Stack>
            </Card>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
